import 'bootstrap.collapse';
import '/assets/theme/js/mmenu-light.js?v=2';
import { registerComponents } from 'component-utils';
import components from 'core-components';
import $ from 'jquery';
import 'global';

onLoad();

document.addEventListener('DOMContentUpdated', e => onLoad(e.target));

export function onLoad(context = document) {
    // Register the components (if applicable).
    if (context instanceof Document && config.registerComponents !== false)
        registerComponents(components);

    // Scroll To
    context.querySelectorAll('.scroll-to').forEach(link => {
        link.addEventListener('click', e => {
            e.preventDefault();
            const href = this.getAttribute('href');
            const offsetTop = context.querySelector(href).offsetTop;

            window.scroll({
                top: offsetTop,
                behavior: 'smooth'
            });
        });
    });

    // Back to top after set scroll add class to show it.
    window.addEventListener('scroll', () => {
        if (window.scrollY > 200)
            $('#back-to-top').addClass('show');
        else
            $('#back-to-top').removeClass('show');
    });


    // Scroll To Top of page
    context.querySelectorAll('.scroll-to-top').forEach(link => {
        link.addEventListener('click', e => {
            window.scroll({
                top: 0,
                behavior: 'smooth'
            });
        });
    });

    //ScrollReveal().reveal('.reveal', { duration: 1000, interval: 250 });
    //ScrollReveal().reveal('.service', { duration: 1000, interval: 250 });
    //ScrollReveal().reveal('.cable-assemblies', { duration: 1000, interval: 250 });
    //ScrollReveal().reveal('.sector-wrapper', { duration: 1000, interval: 250 });
    //ScrollReveal().reveal('.news-article', { duration: 1000, interval: 250 });

    const menu = new MmenuLight(document.querySelector('#menu-navbar'), '(max-width: 992px)');

    menu.navigation({
        slidingSubmenus: true,
        title: 'Menu'
    });

    const drawer = menu.offcanvas({
        position: 'left'
    });

    //	Open the menu.
    document
        .querySelector('button[href="#menu-navbar"]')
        .addEventListener('click', (evnt) => {
            evnt.preventDefault();
            drawer.open();
        });
}